import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { IFile } from '@repo/toolkit/types'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

import TransportPicto from '../../../elements/transport-picto'
import { tripBookingTypeMapping } from '../../trip-bookings/trip-booking.ui'

type Props = {
  tripName: string
  type: 'main' | 'secondary'
  showLabel?: boolean
  picto?: IFile
}

const TripFolderReservationHeader = ({ tripName, type, picto, showLabel = true }: Props) => {
  const bookingTypeMapping = tripBookingTypeMapping[type]

  return (
    <div className="flex w-full gap-2 items-center">
      {picto && <TransportPicto picto={picto} />}
      <Typography variant="secondary-body" color={tailwindColors.secondary.DEFAULT}>
        {tripName}
      </Typography>
      {showLabel && (
        <Badge
          variant={bookingTypeMapping.variant}
          text={
            <Typography variant="label-semibold" color={bookingTypeMapping.value}>
              {bookingTypeMapping.label}
            </Typography>
          }
        />
      )}
    </div>
  )
}

export default TripFolderReservationHeader
